/* angular:styles/component:css;ebd4e2f3340bde695e7dc12be3db31ac41781462db8987514c8cbc0fbb50c703;C:\RDF\github-dev\fusion-web\src\app\components\template-editor\template-editor.component.ts */
.tpl-editor {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}
.tpl-toolbar {
  padding: 6px;
  border-bottom: 1px solid #dee2e6;
  flex-wrap: wrap;
  gap: 4px 0;
}
.tpl-format {
  min-width: 120px;
}
.tpl-content {
  overflow-y: auto;
  padding: 10px;
}
.tpl-editor-readonly .tpl-content {
  background: #f8f9fa;
}
/*# sourceMappingURL=template-editor.component.css.map */
